import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const USERS = [
    { id: "1", email: "ad@atomone.in", password: "atom17", role: "admin" },
    { id: "2", email: "teja@atomone.in", password: "atom17", role: "admin" },
    { id: "3", email: "hussain@atomone.in", password: "hussainb@123", role: "operator" },
    { id: "4", email: "user@atomone.in", password: "user@1237", role: "operator" },
    { id: "5", email: "pankaj@atomone.in", password: "pankaj.17", role: "admin" },
  ];

  useEffect(() => {
    const savedUser = localStorage.getItem("authUser");

    if (savedUser) {
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    }
  }, []);

  const login = (email, password) => {
    const validUser = USERS.find(
      (u) => u.email === email && u.password === password
    );

    if (!validUser) return false;

    const userName = email.split("@")[0];

    const userData = {
      userId: validUser.id,
      userName,
      email,
      role: validUser.role,
    };

    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem("authUser", JSON.stringify(userData));

    return true;
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem("authUser");
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
